export default __webpack_public_path__ + "hero-56c46cc59469e09e5fb97c02b2e2a916.digested.jpg";